export enum AppointmentTimeOfDay {
  None = 0,
  Morning = 1,
  Afternoon = 2,
  Evening = 4
}